import { Basic } from "./Basic";

export const Pagination = {
  Basic,
};
